export const auth = {
  authHomeTitle: 'Welkom!',
  authHomeButtonBranded: 'Doorgaan met Email',
  authHomeButtonApple: 'Doorgaan met Apple',
  authHomeButtonGoogle: 'Doorgaan met Google',
  authHomeButtonFacebook: 'Doorgaan met Facebook',
  authHomeButtonLinkedin: 'Doorgaan met LinkedIn',
  authStartTitle: 'Voer E-mail in',
  authStartInputTitle: 'E-mail',
  authStartInputTitleError: 'Voer een geldig e-mailadres in!',
  authStartInputPasswordError: 'Voer een geldig wachtwoord in!',
  authWhoops: 'Oeps!',
  authStartConfirmButton: 'Doorgaan',
  authRegisteredTitle: 'Welkom terug!',
  authStartPlaceholderTitle: 'E-mail',
  authRegisteredInputTitle: 'Wachtwoord',
  authRegisteredForgotPassword: 'Wachtwoord vergeten',
  authAlertIncorrectPassword: 'Uw e-mailadres of wachtwoord is onjuist',
  authAlertRequiredPassword: 'Voer een geldig wachtwoord in',
  authFinishSignUpTitle: 'Voltooi de registratie',
  authFinishSignUpEmailInputTitle: 'E-mail',
  authFinishSignUpFirstNameInputTitle: 'Voornaam',
  authFinishSignUpLastNameInputTitle: 'Achternaam',
  authFinishSignUpPasswordInputTitle: 'Wachtwoord',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">We raden aan om te gebruiken:</li><li class="list-disc">Minimaal 8 tekens</li><li class="list-disc">Ten minste 1 cijfer</li><li class="list-disc">Ten minste 1 speciaal teken</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Door te klikken op Registreren gaat u akkoord met onze',
    privacyPolicy: 'Privacybeleid',
    text2: 'en',
    termsOfUse: 'Gebruiksvoorwaarden'
  },
  authFinishSignUpConfirmButton: 'Registreren',
  authFinishSignUpErrorFirstName: 'Voornaam mag niet leeg zijn!',
  authFinishSignUpErrorLastName: 'Achternaam mag niet leeg zijn!',
  authFinishSignUpErrorPassword: 'U heeft een te kort wachtwoord gekozen!',
  authEmailConfirmationTitle: 'Controleer uw e-mail',
  authEmailConfirmationContent:
    'We hebben een bevestigingsmail gestuurd om uw e-mailadres te verifiëren. Controleer alstublieft ook uw spammap als u de e-mail niet in uw hoofdmap kunt vinden',
  authEmailConfirmationConfirmButton: 'Ga naar het hoofdscherm',
  authAlertEmailConfirmation: 'U heeft uw e-mail nog steeds niet bevestigd - controleer uw e-mailinbox!',
  authResetPasswordTitle: 'Controleer uw e-mail',
  authResetPasswordDescription:
    'We hebben een link om uw wachtwoord te resetten naar uw e-mail gestuurd. Controleer alstublieft ook uw spammap als u de e-mail niet in uw hoofdmap kunt vinden',
  authResetPasswordButton: 'Naar de startpagina',
  authNewPasswordTitle: 'Voer nieuw wachtwoord in',
  authNewPasswordInputTitle: 'Nieuw wachtwoord',
  authNewPasswordButton: 'Wachtwoord resetten',
  authNewPasswordAlertValidation: 'Uw wachtwoord is te gemakkelijk!',
  authPasswordChangeSuccessTitle: 'Wachtwoord gewijzigd!',
  authPasswordChangeSuccessContent: 'U heeft uw wachtwoord succesvol gewijzigd!',
  authPasswordChangeSuccessButton: 'Naar de startpagina',
  authPasswordChangeErrorTitle: 'Er is een fout opgetreden!',
  authPasswordChangeErrorContent: 'Er is iets misgegaan tijdens het resetten van uw wachtwoord! Probeer het later opnieuw.',
  authPasswordChangeErrorButton: 'Naar de startpagina',
  authInvitationTitle: 'Kies een wachtwoord',
  authInvitationInputTitle: 'Wachtwoord',
  authInvitationButton: 'Kies wachtwoord',
  authEmailAddressConfirmed: 'Uw e-mailadres is bevestigd!'
}
